import { backend } from '../services/backend';
import { UploadIcon } from '../icons/upload';
import React, { useState } from 'react';
import { toast } from 'sonner';
import { userBackend } from '../services';

interface ModalLoaderProps {
  photoUrl: string;
  title: string;
  closeModal: () => void;
}

const PhotoWatchModal: React.FC<ModalLoaderProps> = ({ photoUrl, title, closeModal }) => {

  return (
    <div>
      <div className="modalHeading">
        <h3>{title || "Фото"}</h3>
      </div>
      <div className="watchPhotoContainer">
        <img
          src={photoUrl}
          alt="Preview"
          className="photoPreview"
        />
      </div>
      <div className="flex between">
        <button onClick={closeModal} className="cancelButton">
          Закрыть
        </button>
      </div>
    </div>
  );
};

export default PhotoWatchModal;